import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useDropzone } from 'react-dropzone'
import { hashCode } from '../../utils/utils'
import Button from '../../components/Button'
import { cancelUploadAction, uploadAction } from '../../utils/actions'
import { sendMsgAction } from '../utils/actions'

export const uploadHeader = (
  <h3>Upload File</h3>
)

export const uploadBody = (props) => {
  const dispatch = useDispatch()

  const onDrop = useCallback(acceptedFiles => {
    const reader = new FileReader()
    reader.onload = () => {
      const binaryStr = reader.result
      // let calculation = null
      let uploadedObj = null

      try {
        // calculation = JSON.parse(binaryStr)
        uploadedObj = JSON.parse(binaryStr)
      } catch (error) {
        console.log('JSON.parse error:', error)
      }

      if (!!uploadedObj && !!uploadedObj.hash && !!uploadedObj.source) {
        const hashFromDownload = uploadedObj.hash

        const uploadedSourceStr = JSON.stringify(uploadedObj.source, null, 0)
        const computedHash = hashCode(uploadedSourceStr)

        // console.log('hashFromDownload=', hashFromDownload, ' calculationHash=', calculationHash)
        // console.log('calculation.source=', calculation.source)

        if (hashFromDownload === computedHash) {
          const { appCode, appVersion, calculation } = uploadedObj.source

          if (appCode === props.appConfig.appCode /* && appVersion === props.appConfig.appVersion */) {
            dispatch(uploadAction(uploadedObj.source))
            dispatch(sendMsgAction({ msgLevel: 'success', msgBody: 'File uploaded' }))
          } else {
            dispatch(sendMsgAction({ msgLevel: 'error', msgBody: 'Invalid app; upload rejected' }))
          }
        } else {
          dispatch(sendMsgAction({ msgLevel: 'error', msgBody: 'Invalid file found; upload rejected' }))
        }
      } else {
        dispatch(sendMsgAction({ msgLevel: 'error', msgBody: 'Invalid file format; upload rejected' }))
      }
    }
    acceptedFiles.forEach(file => reader.readAsText(file))
    props.uploadModal.closeModal()
  }, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})
  const getDropzoneInputProps = Object.assign({}, getInputProps(), {multiple: false})

  return (
    <div className="fileUploadZone" {...getRootProps()}>
      <span className="">
        <span>Drag and drop a file here or </span>
        <button type="button" className="button -link">
          <span className="button__text">browse files</span>
        </button>
      </span>
      <input {...getDropzoneInputProps} />
    </div>
  )
}

export const uploadFooter = (props) => {
  const dispatch = useDispatch()

  const handleCancel = () => {
    props.uploadModal.closeModal()
    dispatch(cancelUploadAction())
    dispatch(sendMsgAction({ msgBody: 'File upload cancelled.' }))
    // gaEventWrapper(gaEventName, 'Upload_Action', 'Upload - message:upload cancelled')
  }

  return (
    <Button variant="tertiary" onClick={handleCancel} >
      <span className="material-icons">close</span>
      <span className="button__text">Cancel</span>
    </Button>
  )
}
